import { useEffect, useState } from "react";

// The palette is mounted more than once (the sidebar rail and the mobile nav
// icon, plus a second pair inside drawer-nested Layouts). Open state lives in
// one module-level store keyed by which trigger opened it, so ⌘K and a tap can
// never stack two palettes and Escape always closes the one on screen.
let openerId: string | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const openPalette = (id: string) => {
  openerId = id;
  emit();
};

export const closePalette = () => {
  openerId = null;
  emit();
};

export const isPaletteOpen = () => openerId !== null;

/** True only for the instance that opened the palette — the one that renders it. */
export const usePaletteOwner = (id: string) => {
  const [owned, setOwned] = useState(() => openerId === id);

  useEffect(() => {
    const listener = () => setOwned(openerId === id);
    listeners.add(listener);
    listener();
    return () => {
      listeners.delete(listener);
    };
  }, [id]);

  return owned;
};
